import React from 'react';
import PropTypes from 'prop-types';

import {black500} from "assets/jss/main";

ButtonActionContainer.propTypes = {
    children: PropTypes.node
};

function ButtonActionContainer(props) {
    return (
        <div style={{color: black500, display: 'flex', gap: '12px'}}>
            {props.children}
        </div>
    );
}

export default ButtonActionContainer;
